module.exports = __webpack_public_path__ + "images/chatoffices_logo.png";